import { render, staticRenderFns } from "./QZTrayManagement.vue?vue&type=template&id=581f20c2"
import script from "./QZTrayManagement.vue?vue&type=script&lang=js"
export * from "./QZTrayManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports